/**@jsx jsx */
import { jsx } from "theme-ui";
import { AppContext } from "../context/AppContext";
import { Location, Phone } from "./Icons";
import { useContext } from "react";
import { colors } from "../gatsby-plugin-theme-ui/colors";

const Sidebar = () => {
	const { isSidebarOpen } = useContext(AppContext);
	return (
		<aside
			sx={{
				position: "fixed",
				zIndex: 1000,
				top: "75px",
				left: 0,
				width: "100%",
				py: "32px",
				opacity: isSidebarOpen ? 1 : 0,
				transform: isSidebarOpen ? "translateY(0)" : "translateY(-100%)",
				transition: "all 0.3s ease-in-out",
				background: "#f9f9f9",
				display: ["block", null, null, "none"],
				boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
			}}
		>
			<ul
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "100%",
					justifyContent: "center",
					alignItems: "end",
					gap: "20px",
					pr: "20px",
				}}
			>
				<li
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "center",
					}}
				>
					<Location fill={colors.moneyGreen} />
					<a
						sx={{ variant: "text.navLink" }}
						href="https://www.google.com/maps/search/?api=1&query=36.85667059967011%2C-76.20202207151335&query_place_id=ChIJC6NlHUKWuokRe2iY874ih8A"
						target="_blank"
					>
						Locations
					</a>
				</li>
				<li
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "center",
					}}
				>
					<Phone fill={colors.moneyGreen} />
					<a
						sx={{
							variant: "text.navLink",
							display: "inline-block",
							my: 2,
						}}
						href="tel:855-920-9800"
					>
						855-920-9800
					</a>
				</li>
			</ul>
		</aside>
	);
};

export default Sidebar;
